/**
 * SendGiftSheet
 *
 * Helper to open the send-gift bottom sheet via SheetService.
 * Mirrors UnlockContentSheet pattern.
 *
 * Usage:
 *   // content gift:
 *   SendGiftSheet.show({ kind: SendGiftTargetType.media, media }, title, container, screenKey, defaultGift);
 *   // chat gift:
 *   SendGiftSheet.show({ kind: SendGiftTargetType.chat, peerUser }, title, container, screenKey);
 *   // video-call gift:
 *   SendGiftSheet.show({ kind: SendGiftTargetType.videoCall, callerUser, audienceUser, callMessageId }, title, container, screenKey);
 *   // live-streaming gift (audience tip):
 *   SendGiftSheet.show({ kind: SendGiftTargetType.liveStreaming, broadcasterFirebaseId, broadcasterName, liveStreamingMessageId }, title, container, screenKey);
 *
 * Flutter: lib/services/navigation_service.dart -> showSendGiftSheet()
 */
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { SendGiftSheetContent } from './SendGiftSheetContent';
import type { SendGiftTarget } from '@/presentation/feature/gift/hooks/useSendGift';
import type { GiftEntity } from '@/domain/entities/gift/giftEntity';

const show = (
  target: SendGiftTarget,
  title: string,
  container?: HTMLElement | string | null,
  screenKey?: string,
  defaultGift?: GiftEntity,
) => {
  SheetService.show({
    title,
    content: (
      <SendGiftSheetContent
        target={target}
        screenKey={screenKey}
        defaultGift={defaultGift}
        onClose={() => SheetService.close()}
      />
    ),
    container,
    screenKey,
    qaId: 'send-gift',
    closeOnClickOutside: true,
  });
};

export const SendGiftSheet = {
  show,
};
